module.exports = __webpack_public_path__ + "static/partnerBlockBack-0caa16f5c3713da53bb223f521f3c640.png";